const AlertTriangleError = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.42347 2.17175C7.1341 0.976605 8.86447 0.976602 9.5751 2.17175L14.5644 10.5629C15.2911 11.7849 14.4104 13.3332 12.9886 13.3332H3.00997C1.58819 13.3332 0.707518 11.7849 1.43415 10.5629L6.42347 2.17175ZM7.99935 5.33317C8.27549 5.33317 8.49935 5.55703 8.49935 5.83317V8.49984C8.49935 8.77598 8.27549 8.99984 7.99935 8.99984C7.72321 8.99984 7.49935 8.77598 7.49935 8.49984V5.83317C7.49935 5.55703 7.72321 5.33317 7.99935 5.33317ZM8.66602 10.3332C8.66602 10.7014 8.36754 10.9998 7.99935 10.9998C7.63116 10.9998 7.33268 10.7014 7.33268 10.3332C7.33268 9.96498 7.63116 9.6665 7.99935 9.6665C8.36754 9.6665 8.66602 9.96498 8.66602 10.3332Z"
      />
    </svg>
  )
}

export default AlertTriangleError
